import { server } from '../core/server/axios';
import { BACKEND_URL } from '@/core/config';

export interface LimitsModel {
	currencyCode: string;
	currencyId: number;
	currentBalance: number;
	currentDeviationPercent: number;
	currentDeviationValue: number;
	deliveryTime: string;
	depType: 'buying' | 'selling';
	departmentId: number;
	departmentName: string;
	deviationAmount: number;
	deviationPercent: number;
	isActive: boolean;
	isSystem: boolean;
	limitAmount: number;
	limitAmountCurrency: number;
	limitAmountTenge: number;
	limitId: number;
	periodDays: number;
	region: string;
	updatedBy: 'bgworker' | 'manual' | string;
	manualLimitCurrency: number;
	manualLimitKzt: number;
}

export interface UpdateLimitVariables {
	limitId: number,
	depType?: "buying" | "selling" | null,
	periodDays?: number | null,
	deviationPercent?: number | null,
	deliveryTime?: string | null,
	isSystem?: boolean | null,
	limitAmount?: number | null,
	limitAmountCurrency?: number | null,
	limitAmountTenge?: number | null,
	manualLimitCurrency?: number | null,
	manualLimitKzt?: number | null,
	updatedBy?: "bgworker" | "manual" | string | null
}

export class LimitsController {
	async getLimitsList(depId?: string | number): Promise<LimitsModel[]> {
		return await server.get(`/Limit/list${depId ? `?departmentId=${depId}` : ""}`, {
			baseURL: BACKEND_URL
		});
	}

	async getLimit(limitId: string | number): Promise<LimitsModel> {
		return await server.get(
			`/Limit/${limitId}`, {
			baseURL: BACKEND_URL
		});
	}

	async updateLimit({
		limitId,
		depType = null,
		periodDays = null,
		deviationPercent = null,
		deliveryTime = null,
		isSystem = null,
		limitAmount = null,
		limitAmountCurrency = null,
		limitAmountTenge = null,
		updatedBy = null,
		manualLimitCurrency = null,
		manualLimitKzt = null,
	}: UpdateLimitVariables): Promise<LimitsModel> {
		return await server.post(
			'/Limit/update-limit',
			{
				limitId,
				depType,
				periodDays,
				deviationPercent,
				deliveryTime,
				isSystem,
				limitAmount,
				limitAmountCurrency,
				limitAmountTenge,
				manualLimitCurrency,
				manualLimitKzt,
				updatedBy,
			},
			{
				baseURL: BACKEND_URL
			});
	}

	async updateLimitMany(body: UpdateLimitVariables[]): Promise<LimitsModel[]> {
		return await server.post(
			'/Limit/update-many',
			body,
			{
				baseURL: BACKEND_URL
			});
	}

	async createLimit(body: { departmentId: number, currencyId: number, isSystem: boolean, updatedBy: string }): Promise<LimitsModel> {
		return await server.post(
			'/Limit/create',
			body,
			{
				baseURL: BACKEND_URL
			});
	}
}